import type { QueryClient } from '@tanstack/react-query';
import type { InboxItem } from '@/types';

export const INBOX_QUERY_KEY = ['messages', 'inbox'] as const;

export function clearInboxPartnerUnread(queryClient: QueryClient, partnerId: string): void {
  queryClient.setQueryData<InboxItem[]>(INBOX_QUERY_KEY, (old) => {
    if (!old) return old;
    let changed = false;
    const next = old.map((item) => {
      if (item.partnerId !== partnerId || item.unreadCount === 0) return item;
      changed = true;
      return { ...item, unreadCount: 0 };
    });
    return changed ? next : old;
  });
}
